<template>
 <div class="newslist">
 <div class="title">
      <span class="box-name">新闻图片</span>

    </div>
    <div class="pic">
      <lunboMin></lunboMin>
    </div>
  </div>
</template>

<script>
import lunboMin from '@/views/front/components/lunboMin';
export default {
  name: 'rightpic',
  components: {
    lunboMin
  },
  data () {
     return {

   }
  },
  methods: {

  }
};
</script>

<style scoped>
  .newslist{
    width: 100%;
  }
.title{
  height:36px;
  line-height:36px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #199352;
}
.title .box-name{
  font-size:14px;
  color:#fff;
  background: #199352;
  font-weight: bold;
  padding:0 10px;
}
.title .more{
  color:#515151;
  font-size:12px;
  padding-right:15px;
  background: url(../../../assets/img/1.png) no-repeat right center;
}

.pic{
  border:1px solid #cdcdcd;
  width:100%;
  height:200px;
  margin:20px 0;
}
.pic img{
  width:100%;
  height:200px;
}
</style>



// WEBPACK FOOTER //
// src/views/front/components/rightpic.vue